import { useStatefulFields } from "../../hooks/useStatefulFields";
import { useAuthSubmit } from "../../hooks/useAuthSubmit";
import {
  Typography,
  TextField,
  Button,
  Stack,
  Container,
  FormHelperText,
  Divider,
  Alert,
} from "@mui/material";
import { Link, useSearchParams } from "react-router-dom";
import ContentStyle from "./ContentStyle";
import { useFeature } from "../../hooks";

const MICROSOFT_SSO_ERRORS = {
  microsoft_sso_cancelled: "Microsoft-login blev annulleret.",
  microsoft_sso_no_org:
    "Din Microsoft-organisation er ikke tilsluttet DORA. Kontakt din administrator.",
  microsoft_sso_email_conflict:
    "Denne e-mail er allerede tilknyttet en anden DORA-organisation.",
  microsoft_sso_disabled: "Din bruger er blevet deaktiveret. Kontakt din administrator.",
  microsoft_sso_no_group_access:
    "Din Microsoft-konto har ikke adgang til DORA. Kontakt din administrator.",
  microsoft_sso_error:
    "Noget gik galt med Microsoft-login. Forsøg venligst igen.",
};

export default function LoginForm() {
  const [values, handleChange] = useStatefulFields();
  const [error, handleSubmit] = useAuthSubmit("/login", values);
  const [searchParams] = useSearchParams();
  const ssoError = searchParams.get("error");
  const ssoErrorMessage = MICROSOFT_SSO_ERRORS[ssoError] || null;
  const microsoftSsoEnabled = useFeature("microsoft-sso");

  return (
    <>
      <ContentStyle>
        <Container sx={{ p: 3, mt: 16 }} maxWidth="xs">
          <form autoComplete="on">
            <Stack spacing={3}>
              <Typography variant="h4">Log ind</Typography>
              <TextField
                id="login-email-field"
                autoFocus
                fullWidth
                name="email"
                label="E-mail"
                type="email"
                variant="outlined"
                onChange={handleChange}
              />
              <TextField
                id="login-password-field"
                fullWidth
                name="password"
                label="Password"
                type="password"
                variant="outlined"
                onChange={handleChange}
              />
              {error && (
                <FormHelperText error>
                  Noget gik galt, forsøg venligst igen.
                </FormHelperText>
              )}
              <Button
                id="login-submit-button"
                color="primary"
                fullWidth
                type="submit"
                variant="contained"
                onClick={handleSubmit}
              >
                Log in
              </Button>
              <Link to="/welcome/reset">
                <Button variant="text">Glemt password?</Button>
              </Link>
              {microsoftSsoEnabled && (
                <>
                  <Divider>or</Divider>
                  {ssoErrorMessage && (
                    <Alert severity="error">{ssoErrorMessage}</Alert>
                  )}
                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={() => {
                      window.location.href =
                        "/auth/microsoft/initiate?purpose=sign-in";
                    }}
                    startIcon={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 21 21"
                      >
                        <rect x="1" y="1" width="9" height="9" fill="#f25022" />
                        <rect
                          x="11"
                          y="1"
                          width="9"
                          height="9"
                          fill="#7fba00"
                        />
                        <rect
                          x="1"
                          y="11"
                          width="9"
                          height="9"
                          fill="#00a4ef"
                        />
                        <rect
                          x="11"
                          y="11"
                          width="9"
                          height="9"
                          fill="#ffb900"
                        />
                      </svg>
                    }
                  >
                    Log ind med Microsoft
                  </Button>
                </>
              )}
            </Stack>
          </form>
        </Container>
      </ContentStyle>
    </>
  );
}
